import React from 'react';
import styles from './Modal.module.scss';

const ModalDescription = ({ text }) => (
  <div className={styles.description}>{text}</div>
);

export default ModalDescription;
